var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryNp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8908)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.89543 -1.06478e-09 2 0L2.46482 4.56679e-10C2.59643 5.84276e-10 2.7251 0.0389587 2.83462 0.111966L15.0026 8.22393C16.1002 8.9557 15.5822 10.6667 14.263 10.6667H8L15.9961 17.6632C16.9226 18.474 16.3492 20 15.1181 20H2C0.895428 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.89543 -1.06478e-09 2 0L2.46482 4.56679e-10C2.59643 5.84276e-10 2.7251 0.0389587 2.83462 0.111966L15.0026 8.22393C16.1002 8.9557 15.5822 10.6667 14.263 10.6667H8L15.9961 17.6632C16.9226 18.474 16.3492 20 15.1181 20H2C0.895428 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1181 19.3333H0.666667V0.666667L2.46482 0.666667L14.6328 8.77863C15.1816 9.14452 14.9226 10 14.263 10H8C7.72226 10 7.47362 10.1722 7.37593 10.4322C7.27824 10.6922 7.35198 10.9855 7.561 11.1684L15.5571 18.1649C16.0203 18.5703 15.7336 19.3333 15.1181 19.3333Z",
    fill: "#EE1B44",
    stroke: "#0543A8",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8511 7.80079C7.23521 7.69552 7.58932 7.55155 7.90252 7.37616C7.59187 8.50453 6.55836 9.33336 5.33126 9.33336C4.10417 9.33336 3.07066 8.50453 2.76001 7.37616C3.07407 7.55204 3.42928 7.69632 3.81462 7.80166L4.33334 7.33335L3.48558 6.56799L4.62624 6.62625L4.56798 5.4856L5.33334 6.33335L6.09871 5.4856L6.04045 6.62625L7.1811 6.56799L6.33334 7.33335L6.8511 7.80079ZM4.31297 17.1304L5.33346 16L6.35395 17.1304L6.27627 15.6095L7.79714 15.6872L6.66679 14.6667L7.79714 13.6462L6.27627 13.7239L6.35395 12.203L5.33346 13.3334L4.31297 12.203L4.39065 13.7239L2.86978 13.6462L4.00013 14.6667L2.86978 15.6872L4.39065 15.6095L4.31297 17.1304Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8908"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryNp);
export default __webpack_public_path__ + "static/media/Country=NP.f82efde7e715d1a547977ba0fa11d48b.svg";
export { ForwardRef as ReactComponent };